import { render, staticRenderFns } from "./BezelSelector.vue?vue&type=template&id=de5e0318&"
import script from "./BezelSelector.vue?vue&type=script&lang=js&"
export * from "./BezelSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports